import {useEffect, useState} from "react";

import daapappLogo from "../../Assets/Images/logo_green.png";
import arshiyanLogo from "../../Assets/Images/arshiyan.svg";
import "./styles.css";

const Logo = () => {
    const [isArshiyanLogo, setIsArshiyanLogo] = useState(null);

    useEffect(() => {
        const url_string = window.location.href;
        const url = new URL(url_string);
        let co = url.searchParams.get("co");
        if (co === "arshiyan") {
            setIsArshiyanLogo(true);
        }
    }, []);


    return (
        <>
            {
                isArshiyanLogo ?
                    <>
                        <img
                            className="app-logo"
                            src={arshiyanLogo}
                        />
                        <p style={{color:"rgb(10, 35, 76)"}} className="font-weight-bold mt-3 mb-5">گروه بین المللی عرشیان</p>
                    </>
                    :
                    <img
                        className="app-logo"
                        src={daapappLogo}
                    />
            }

        </>
    )
        ;
};
export default Logo;